import { useFormikContext } from "formik";
import { useEffect, useMemo } from "react";

import useMultisportPageId from "web/hooks/useMulstisportPageId/useMultisportPageId";

import isMultisportPhrase from "./isMultisportPhrase";

const useMultisportSearch = (searchPhrase: string): void => {
  const multisportPageId = useMultisportPageId();
  const { setFieldValue } = useFormikContext<{
    [key: string]: string | boolean;
  }>();

  const hasMultisport = useMemo(() => {
    const isMultisportEnabled = typeof multisportPageId === "number";

    if (!isMultisportEnabled) {
      return false;
    }

    return isMultisportPhrase(searchPhrase);
  }, [searchPhrase, multisportPageId]);

  useEffect(() => {
    setFieldValue("hasMultisport", hasMultisport);
  }, [hasMultisport, setFieldValue]);
};

export default useMultisportSearch;
